import { useLocalSearchParams } from 'expo-router'

import { OtpCodeScreen } from '@/src/features/auth/ui/screens/OtpCodeScreen'
import { filterSearchParams } from '@/src/general/utils/filterSearchParams'

export default () => {
  const { redirectTo } = filterSearchParams(useLocalSearchParams())
  return <OtpCodeScreen redirectTo={redirectTo} />
}
